import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { IndicatorAction } from '../../../models/indicator.models';
import { IconComponent } from '../../atoms/icon/icon.component';
import { TooltipDirective } from '@ui';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-actions-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TooltipDirective, TranslocoDirective],
  template: `
    <div class="flex flex-row flex-wrap gap-x-2" *transloco="let t">
      @for (action of actionsComputed(); track action) {
        <ui-icon
          uiTooltip
          [tooltipTitle]="tooltipTitleTemplate"
          [icon]="getState(action.id).icon"
          class="text-lg duration-300 transition-all"
          [class]="
            action.disabled
              ? 'text-neutral-6'
              : 'cursor-pointer hover:text-primary'
          "
          (click)="emitAction(action)"
        />
        <ng-template #tooltipTitleTemplate let-data>
          <div class="flex flex-col items-center text-xs mt-0.5">
            {{ t(getState(action.id).title) }}
          </div>
        </ng-template>
      }
    </div>
  `,
})
export class ActionsIndicatorComponent {
  protected readonly ACTIONS_STATE: Record<IndicatorAction, { icon: string, title: string }> =
    {
      archive: { icon: 'icons:bell-off', title: 'ACTIONS.MARK_AS_READ' },
      edit: { icon: 'edit', title: 'ACTIONS.EDIT' },
      delete: { icon: 'delete', title: 'ACTIONS.DELETE' },
      view: { icon: 'eye', title: 'ACTIONS.VIEW' },
      'view-saved': { icon: 'eye', title: 'ACTIONS.VIEW' },
    };

  actions = input.required<Partial<Record<IndicatorAction, { disabled: boolean }>>>();
  actionsComputed = computed(() =>
    this.actions()
      ? Object.entries(this.actions()).map(([key, value]) => ({
          id: key as IndicatorAction,
          ...value,
        }))
      : [],
  );
  onAction = output<IndicatorAction>();

  getState(action: IndicatorAction) {
    return this.ACTIONS_STATE[action];
  }

  emitAction(action: { disabled: boolean; id: IndicatorAction }) {
    if (!action.disabled) this.onAction.emit(action.id);
  }

  getActionTitle(id: IndicatorAction): string {
    return id ? (id.charAt(0).toUpperCase() + id.slice(1)) : '';
  }
}
